 import { Component, OnInit } from '@angular/core';
import { RouterLinkActive } from '../../../../node_modules/@angular/router';
import { MenuModel,DisplayMenuModel } from '../../Model/Menu/menu.model';
import { ResponseModel } from '../../Model/response.model';
import {MenuService} from '../../Service/Menu/menu.service';
import {RouterModule, Routes,Router } from '@angular/router';
import {ContentComponent} from '../../Component/content/content.component'
import {HomeComponent } from 'src/app/Component/home/home.component';
import {MenuDataService} from '../../Service/Common/menudata.service';
import {HomeService} from '../../Service/Home/home.service';
import {HomeModel} from '../../Model/Home/home.model';
import {LeftTopBannerModel} from '../../Model/LeftTopBanner/leftTopBanner.model';
import {RightTopBannerModel} from '../../Model/RightTopBanner/RightTopBanner.model';
import {environment} from '../../../environments/environment';
import { StreamComponent } from '../../Component/stream/stream.component';
import {BlogsComponent} from '../../Component/blogs/blogs.component';
import {NewsComponent} from '../../Component/news/news.component';
import {CustomFormComponent} from '../../Component/customform/customform.component';
import {ToolsComponent} from '../../Component/tools/tools.component';
import {TournamentsComponent} from '../../Component/tournaments/tournaments.component'
import { AboutusComponent } from '../../Component/aboutus/aboutus.component';
import { ProamateurtournamentComponent } from '../../Component/proamateurtournament/proamateurtournament.component';
import { RegularstreamComponent } from '../../Component/regularstream/regularstream.component';
import { AxieleagueComponent } from '../../Component/axieleague/axieleague.component';
import { SponsorComponent } from '../../Component/sponsor/sponsor.component';
import { RankingComponent } from '../../component/ranking/ranking.component';
import { ScheduleComponent } from '../../component/schedule/schedule.component';
import { StatisticsComponent } from '../../component/statistics/statistics.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  MenuList: MenuModel[];  
  DisplayMenuList:DisplayMenuModel[];
  selectedMenuItem:MenuModel;
  homeData:HomeModel;
  leftTopBannerImage:any;
  rightTopBannerImage:any;
  RightTopBanner: RightTopBannerModel;
  LeftTopBanner:LeftTopBannerModel;
  imageFolder:string;
  whenClicked:boolean;
  sIndex: number;
  dropdownClass:any;
  constructor(private _MenuService: MenuService, private _HomeService:HomeService, private router:Router,private _MenuDataService:MenuDataService) {
      this.DisplayMenuList=[];
      this.imageFolder=environment.imageFolder;
    }

ngOnInit()
{

  this.GetMenu();
}

subMenuChange(menuItem:MenuModel)
{

  this.selectedMenuItem=menuItem;
  this.MenuList.forEach(obj => {
    var navclass='nav-item';
  
   if(obj.id==menuItem.id){
    obj.isActive=true;        
    navclass=navclass+' active';
   }else{
    obj.isActive=false;
   }
     
   obj.navClass=navclass;
  }); 
    this._MenuDataService.changeMenu(this.selectedMenuItem);    
}



menuChange(menuItem:DisplayMenuModel)
{
  var menu=new MenuModel();
  menu.parentId=menuItem.parentId;
  menu.id=menuItem.id;
  menu.isActive=menuItem.isActive;
  menu.sequence=menuItem.sequence;
  menu.title=menuItem.title;
  menu.routeName=menuItem.routeName;
  this.selectedMenuItem=menu;
  this.MenuList.forEach(obj => {
    var navclass='nav-item';
    if(menuItem.haveSubMenu){
      navclass=navclass+' dropdown';
    }

    if(obj.id==menuItem.id){
      obj.isActive=true;        
      navclass=navclass+' active';
     }else{
      obj.isActive=false;
     }
   
  }); 
    this._MenuDataService.changeMenu(this.selectedMenuItem); 
       
}

GetMenu(){
  this._MenuService.GetMenu().subscribe(
   res => {
     if (res.isSuccess) {
       console.log(res)
       this.MenuList = res.responseData;
     
      
       var isActiveSet=0;
       this.MenuList.forEach(element => {

        if(isActiveSet==0){
          element.isActive=true;
          isActiveSet=1;
        }else{
          element.isActive=false;
        }
        console.log(element.routeName.toLowerCase(),"headername");
        if(element.routeName.toLowerCase()=="home"){
     
          this.router.config.unshift(
          
            { path: element.routeName, component: HomeComponent}   
          );  
        }
        //  else if(element.routeName.toLowerCase()=="streams"){
        //    this.router.config.unshift(
          
        //     //  { path:"", component: HomeComponent}   
        //    );  
        //  }
       
        else if(element.routeName.toLowerCase()=="blogs"){
          this.router.config.unshift(
          
            { path: element.routeName, component: BlogsComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="news"){
          this.router.config.unshift(
          
            { path: element.routeName, component: NewsComponent}   
          );  
        }

        else if(element.routeName.toLowerCase()=="customform"){
          this.router.config.unshift(
          
            { path: element.routeName, component: CustomFormComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="tools"){
          this.router.config.unshift(
          
            { path: element.routeName, component: ToolsComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="aboutus"){
          this.router.config.unshift(
          
            { path: element.routeName, component: AboutusComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="proamateurtournament"){
          this.router.config.unshift(
          
            { path: element.routeName, component: ProamateurtournamentComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="regularstreams"){
          this.router.config.unshift(
          
            { path: element.routeName, component: RegularstreamComponent}   
          );  
        }
        else if(element.routeName.toLowerCase()=="axieleague"){
          this.router.config.unshift(
          
            { path: element.routeName, component: AxieleagueComponent}   
          );  
        }

        else if(element.routeName.toLowerCase()=="sponsors"){
          this.router.config.unshift(        
            { path: element.routeName, component:SponsorComponent }   
          );  
        }

        else if(element.routeName.toLowerCase()=="ranking"){
          this.router.config.unshift(        
            { path: element.routeName, component:RankingComponent }   
          );  
        }

        else if(element.routeName.toLowerCase()=="schedule"){
          this.router.config.unshift(        
            { path: element.routeName, component:ScheduleComponent }   
          );  
        }

        else if(element.routeName.toLowerCase()=="statistics"){
          this.router.config.unshift(        
            { path: element.routeName, component:StatisticsComponent }   
          );  
        }

        else if(element.routeName.toLowerCase()=="streams"){
          this.router.config.unshift(        
            { path: element.routeName, component:StreamComponent }   
          );  
        }

        else if(element.routeName.toLowerCase()=="tournaments"){
          this.router.config.unshift(        
            { path: element.routeName, component:TournamentsComponent }   
          );  
        }


        else{
          this.router.config.unshift(      
            { path: element.routeName, component: ContentComponent}      
          );  
        }       
       });


       this.MenuList = res.responseData;
      
       var isActiveSet=0;
     



       this.MenuList.forEach(element => {

        if(element.parentId==0){
          var menu=new DisplayMenuModel();
          menu.id=element.id;
          menu.isActive=element.isActive;
          menu.parentId=element.parentId;
          menu.sequence=element.sequence; 
          menu.routeName=element.routeName;       
          menu.title=element.title;
          menu.subMenus=[];
          var navclass='nav-item';
          if(menu.haveSubMenu){
            navclass=navclass+' dropdown';
          }
          
         
            menu.navClass=navclass;

          this.MenuList.forEach(subelem => {
            if(subelem.parentId==menu.id){
              menu.subMenus.push(subelem);
            }
          
          });
  
          if(menu.subMenus.length>0){
            menu.haveSubMenu=true;
          }else{
            menu.haveSubMenu=false;
          }
          
          this.DisplayMenuList.push(menu);
          console.log(this.DisplayMenuList);
         
         //  console.log(this.DisplayMenuList[2].routeName);
          // this.DisplayMenuList.forEach(subelem => {
          //   if(subelem.subMenus.length>0){
          //     console.log("menulist",subelem.subMenus);
            
          //     this.dropdownClass="dropdown-toggle"
          //   }
          
         // });
        
  
          
        }
       
        
       });
       
               
     }
   }
  )
 }

 ChangeColor(e){
 
   var classes = e.target.className;
   console.log(e.srcElement);
   console.log(event, event.srcElement.attributes.getNamedItem.name);

  //  classes.push('clicked' )
 
}

BannerImage(){
  this._HomeService.GetHomeContent().subscribe(
    res=>{
      this.homeData = res.responseData;
    }
  )
}
}











